export * from './BuildingGovIcon';
export * from './BuildingGovIcon16Light';
export * from './BuildingGovIcon16Regular';
export * from './BuildingGovIcon16Solid';
export * from './BuildingGovIcon20Light';
export * from './BuildingGovIcon20Regular';
export * from './BuildingGovIcon20Solid';
export * from './BuildingGovIcon24Regular';
export * from './BuildingGovIcon24Solid';
export * from './BuildingGovIcon32Regular';
export * from './BuildingGovIcon64Regular';
